import { HowTo } from '@ecm/data/ArticleHowTo'
import JsonLd from '@ecm/ui/seo/JsonLd'

type HowToJsonLdProps = {
  howTo: HowTo | null
  image: string
  url: string
}

const HowToJsonLd = ({ howTo, image, url }: HowToJsonLdProps) => {
  if (!howTo) {
    return null
  }
  const structuredData = {
    '@type': 'HowTo',
    estimatedCost: {
      '@type': 'MonetaryAmount',
      currency: 'USD',
      value: howTo.cost,
    },
    image,
    name: howTo.stepsHeader,
    step: [
      howTo.steps.map((step, i) => ({
        '@type': 'HowToStep',
        image: step.image,
        name: step.title,
        text: step.text,
        url: `${url}/#step${i + 1}`,
      })),
    ],
    supply: [{ '@type': 'HowToSupply', name: howTo.supply }],
    tool: [{ '@type': 'HowToTool', name: howTo.tool }],
    totalTime: howTo.timeIso,
  }

  return <JsonLd type="HowTo" structuredData={structuredData} />
}

export default HowToJsonLd
